<template>
  <div>
    <template v-if="!value">
      -
    </template>
    <div
      v-else
      v-dompurify-html="value"/>
  </div>
</template>
<script>
export default {
  name: 'settingHtmlView',
  props: {
    value: {
      type: String
    }
  },
}
</script>
